export default {
    url: '',
    template: '<ui-view></ui-view>',
    abstract: true
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/forms/forms/index.js